module.exports = __webpack_public_path__ + "static/img/check4.ef127bae.jpg";